// Azure Environment Variables Template
// This template will be used to generate environment variable JSON files for Azure App Services
// Placeholders will be replaced with actual values during generation

export const AZURE_ENV_TEMPLATE = [
  {
    "name": "APIBaseURL:{tenantName}",
    "value": "https://{tenantName}-scus-app-api.azurewebsites.net/api/v1",
    "slotSetting": true
  },
  {
    "name": "APPINSIGHTS_INSTRUMENTATIONKEY",
    "value": "{APPINSIGHTS_INSTRUMENTATIONKEY}",
    "slotSetting": true
  },
  {
    "name": "APPLICATIONINSIGHTS_CONNECTION_STRING",
    "value": "{APPLICATIONINSIGHTS_CONNECTION_STRING}",
    "slotSetting": true
  },
  {
    "name": "ApplicationInsightsAgent_EXTENSION_VERSION",
    "value": "~2",
    "slotSetting": false
  },
  {
    "name": "Authorize.Net:App_Client_ID",
    "value": "V_pKBOo-QI",
    "slotSetting": true
  },
  {
    "name": "Authorize.Net:App_Client_Secret",
    "value": "e6e526f0-6836-43de-b891-9dbc6e042261",
    "slotSetting": true
  },
  {
    "name": "Authorize.Net:Environment",
    "value": "Production",
    "slotSetting": true
  },
  {
    "name": "AzureAppConfiguration:ConnectionString",
    "value": "Endpoint=https://innova-app-configuration.azconfig.io;Id=Obhy;Secret=2ccZ4OzABE2ElLBp1f0Aw3R9o4MDejNYOeTEryDfeF0DrwQm52gAJQQJ99BJAC1i4TkbJEQuAAACAZAC25A0",
    "slotSetting": true
  },
  {
    "name": "AzureAppConfiguration:Endpoint",
    "value": "https://innova-app-configuration.azconfig.io",
    "slotSetting": true
  },
  {
    "name": "AzureSearch:ApiKey",
    "value": "a0nVGqgsLrq02d06BoEoFdLdpKAMjeqebm0d0bdMiEAzSeCOBh77",
    "slotSetting": true
  },
  {
    "name": "AzureSearch:Endpoint",
    "value": "https://innova-suggestions.search.windows.net",
    "slotSetting": true
  },
  {
    "name": "AzureSearch:IndexNames:{tenantName}",
    "value": "{tenantName}-accounts",
    "slotSetting": true
  },
  {
    "name": "AzureStorage:AccountName",
    "value": "{tenantName}storagearea",
    "slotSetting": true
  },
  {
    "name": "AzureStorage:BaseURL",
    "value": "https://{tenantName}storagearea.blob.core.windows.net",
    "slotSetting": true
  },
  {
    "name": "AzureStorage:ConnectionString",
    "value": "{AzureStorage:ConnectionString}",
    "slotSetting": true
  },
  {
    "name": "AzureStorage:Key",
    "value": "{AzureStorage:Key}",
    "slotSetting": true
  },
  {
    "name": "AzureStorage:LogoContainer",
    "value": "logo",
    "slotSetting": true
  },
  {
    "name": "AzureStorage:PhotoURL",
    "value": "https://{tenantName}storagearea.blob.core.windows.net/images/",
    "slotSetting": true
  },
  {
    "name": "BackOfficeURL:{tenantName}",
    "value": "https//{tenantName}.platformhost.app/",
    "slotSetting": true
  },
  {
    "name": "CORS",
    "value": "{CORS}",
    "slotSetting": true
  },
  {
    "name": "DataOne:AccessKeyID",
    "value": "4fKa3CyrY7",
    "slotSetting": true
  },
  {
    "name": "DataOne:SecretAccessKey",
    "value": "2zzEW8b5ABmHKo7fO59JT3Ec4rhOlgGjPWYnjjFL",
    "slotSetting": true
  },
  {
    "name": "DiagnosticServices_EXTENSION_VERSION",
    "value": "~3",
    "slotSetting": true
  },
  {
    "name": "Environment",
    "value": "{tenantName}",
    "slotSetting": true
  },
  {
    "name": "EquifyAuctionEngineURL:{tenantName}",
    "value": "{tenantName}-scus-app-auctionengine.azurewebsites.net/",
    "slotSetting": true
  },
  {
    "name": "EquifyAuctionsURL:{tenantName}",
    "value": "https://{tenantName}-storefront.platformhost.app/",
    "slotSetting": true
  },
  {
    "name": "StoreFrontURL:{tenantName}",
    "value": "https://{tenantName}-storefront.platformhost.app/",
    "slotSetting": true
  },
  {
    "name": "Firestore_ServiceURL",
    "value": "https://innova-firestore.azurewebsites.net",
    "slotSetting": true
  },
  {
    "name": "Firestore_Tenant_ID",
    "value": "227",
    "slotSetting": true
  },
  {
    "name": "InnovaOffloader",
    "value": "https://innova-offloader-prod.livelyrock-2a6016a2.southcentralus.azurecontainerapps.io/api/",
    "slotSetting": true
  },
  {
    "name": "InstrumentationEngine_EXTENSION_VERSION",
    "value": "disabled",
    "slotSetting": true
  },
  {
    "name": "MediaStorage:AccountName",
    "value": "inspectionapp",
    "slotSetting": true
  },
  {
    "name": "MediaStorage:ConnectionString",
    "value": "DefaultEndpointsProtocol=https;AccountName=inspectionapp;AccountKey=PEhO5a1nYEyDoB68FsfaWlBtxd+WSi2oPzxT/hZW5mLTF3feSgzZqoqE/q8+s5OIhmIBuyekJFYD+AStpngkaA==;EndpointSuffix=core.windows.net",
    "slotSetting": true
  },
  {
    "name": "MediaStorage:Key",
    "value": "PEhO5a1nYEyDoB68FsfaWlBtxd+WSi2oPzxT/hZW5mLTF3feSgzZqoqE/q8+s5OIhmIBuyekJFYD+AStpngkaA==",
    "slotSetting": true
  },
  {
    "name": "SendGrid_Key",
    "value": "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",
    "slotSetting": true
  },
  {
    "name": "SimulcastURL:{tenantName}",
    "value": "{SimulcastURL}",
    "slotSetting": true
  },
  {
    "name": "SmartyStreets:AuthID",
    "value": "2fb03cc1-fe46-813f-5358-1374880b5206",
    "slotSetting": true
  },
  {
    "name": "SmartyStreets:AuthToken",
    "value": "NgG0ioWaAHIor7FWGnuS",
    "slotSetting": true
  },
  {
    "name": "SnapshotDebugger_EXTENSION_VERSION",
    "value": "disabled",
    "slotSetting": true
  },
  {
    "name": "TenantKey",
    "value": "{TenantKey}",
    "slotSetting": true
  },
  {
    "name": "UseLegacyStoreFront",
    "value": "{UseLegacyStoreFront}",
    "slotSetting": true
  },
  {
    "name": "WEBSITE_ENABLE_SYNC_UPDATE_SITE",
    "value": "true",
    "slotSetting": false
  },
  {
    "name": "WEBSITE_NODE_DEFAULT_VERSION",
    "value": "6.9.1",
    "slotSetting": false
  },
  {
    "name": "WEBSITE_RUN_FROM_PACKAGE",
    "value": "1",
    "slotSetting": false
  },
  {
    "name": "XDT_MicrosoftApplicationInsights_BaseExtensions",
    "value": "disabled",
    "slotSetting": true
  },
  {
    "name": "XDT_MicrosoftApplicationInsights_Mode",
    "value": "recommended",
    "slotSetting": true
  },
  {
    "name": "XDT_MicrosoftApplicationInsights_NodeJS",
    "value": "1",
    "slotSetting": true
  },
  {
    "name": "XDT_MicrosoftApplicationInsights_PreemptSdk",
    "value": "disabled",
    "slotSetting": true
  }
];
